import { render, staticRenderFns } from "./FilterSubCategories.vue?vue&type=template&id=6d647e50&scoped=true&"
import script from "./FilterSubCategories.vue?vue&type=script&lang=js&"
export * from "./FilterSubCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d647e50",
  null
  
)

export default component.exports